module.exports = __webpack_public_path__ + "img/btn_query.39dcf73b.png";